// Official Google "G" mark, reproduced at official proportions/colors per
// https://developers.google.com/identity/branding-guidelines — never recolor
// this, even though the button surface follows our own palette.
function GoogleGMark({ className }) {
  return (
    <svg className={className} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.7-.4-3.5z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4c-7.7 0-14.4 4.3-17.7 10.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.3 35.5 26.8 36 24 36c-5.2 0-9.6-3.1-11.3-7.6l-6.6 5.1C9.5 39.6 16.2 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.9 2.5-2.6 4.6-4.8 6.1l6.2 5.2C39.9 36.9 44 31 44 24c0-1.3-.1-2.7-.4-3.5z"
      />
    </svg>
  )
}

export default function GoogleSignInButton({ onClick, loading }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      aria-busy={loading}
      className="w-full min-h-[48px] flex items-center justify-center gap-2.5 rounded-btn
        border border-edge bg-surface text-ink text-body font-body font-semibold
        transition-colors duration-quick ease-out motion-reduce:transition-none
        hover:border-brand hover:bg-blush
        disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:border-edge disabled:hover:bg-surface"
    >
      {loading ? (
        <span
          aria-hidden="true"
          className="w-5 h-5 rounded-full border-2 border-hairline border-t-brand animate-spin motion-reduce:animate-none"
        />
      ) : (
        <GoogleGMark className="w-5 h-5 flex-none" />
      )}
      <span>{loading ? 'Signing in…' : 'Continue with Google'}</span>
    </button>
  )
}
